module.exports = __webpack_public_path__ + "img/p.0643de6d.jpg";